module.exports = __webpack_public_path__ + "img/fuwulc.1a785cf4.png";